export const searchedAppsContainerID = "searchedAppsContainerID";
export const drownDownContainerId = "drownDownContainerId";
